module.exports = __webpack_public_path__ + "static/2-065f903ca62421585b9fef78c0e85ca9.png";